module.exports = "../static/images/0b3acc.gif";